import { motion } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContactModal from './ContactModal';
import { animations } from '../config/animations';

const Hero = () => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <section className='relative min-h-screen flex items-center overflow-hidden'>
        {/* Background Image */}
        <div
          className='absolute inset-0 bg-cover bg-center bg-no-repeat'
          style={{ backgroundImage: 'url(/hero-background.webp)' }}
        >
          {/* Overlay for better text readability */}
          <div className='absolute inset-0 bg-black/40'></div>
        </div>

        {/* Content Container */}
        <div className='relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 flex items-center h-full'>
          <div className='w-full max-w-6xl mx-auto text-center'>
            {/* Main Content */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className='text-center'
            >
              {/* Main Title */}
              <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight font-eras font-bold text-white mb-6 sm:mb-8 drop-shadow-lg'>
                {t('hero.title')}
                <span className='block text-avoprime-light'>
                  {t('hero.subtitle')}
                </span>
              </h1>

              {/* Subtitle */}
              <p className='text-lg sm:text-xl md:text-2xl lg:text-3xl italic font-montserrat text-white mb-8 sm:mb-12 leading-relaxed max-w-3xl mx-auto drop-shadow-md'>
                {t('hero.description')}
              </p>

              {/* CTA Button */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              >
                <button
                  onClick={openContactModal}
                  className='bg-avoprime-primary hover:bg-avoprime-secondary text-white font-eras text-lg sm:text-xl lg:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-2xl shadow-lg border-2 border-white/20 backdrop-blur-sm max-w-full'
                >
                  {t('hero.cta')}
                </button>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Modal */}
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </>
  );
};

export default Hero;
